"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragContainer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
function DragContainer(props) {
    var children = props.children, droppableId = props.droppableId, onDragEnd = props.onDragEnd, _a = props.notDraggable, notDraggable = _a === void 0 ? false : _a;
    if (notDraggable) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
    }
    return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.DragDropContext, { onDragEnd: function (result) {
            onDragEnd === null || onDragEnd === void 0 ? void 0 : onDragEnd(result);
        }, children: (0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Droppable, { droppableId: droppableId, children: function (droppableProvided) {
                var droppableProps = droppableProvided.droppableProps, innerRef = droppableProvided.innerRef, placeholder = droppableProvided.placeholder;
                return ((0, jsx_runtime_1.jsxs)(children.type, __assign({}, children.props, droppableProps, { ref: innerRef, children: [children.props.children, placeholder] })));
            } }) }));
}
exports.DragContainer = DragContainer;
